<script setup lang="ts">
import { watch } from 'vue'
import { useObjectHeader } from '@/widgets/ObjectHeader/model/model.ts'
import { useInventoryMain } from '@/entities/Inventory/Main'
import { VIcons } from '@/shared/ui'

const store = useInventoryMain()
const { getBreadcrumbs } = useObjectHeader()

store.loadGroupMainData()

/**
 * Генерируем событие успешной загрузки данных
 * для использования в родительском компоненте
 */
const emits = defineEmits(['loadData'])

watch(
  () => store.inventory,
  () => {
    emits('loadData', store.inventory)
  },
)
</script>

<template>
  <div class="w-object-header" v-if="store.inventory">
    <div class="w-object-header__info">
      <VBreadcrumbs :items="getBreadcrumbs(store.inventory)">
        <template v-slot:item="{ item }">
          <RouterLink class="v-breadcrumbs-item--link" :to="item.to" v-if="item.to">
            {{ item.title }}
          </RouterLink>

          <div class="v-breadcrumbs-item v-breadcrumbs-item--disabled" v-else>
            <VIcons class="w-content-header__icon" :type="item.icon" />
            {{ item.title }}
          </div>
        </template>
      </VBreadcrumbs>
    </div>
  </div>
</template>
